import Tabs from './Tabs';
import Panel from './Panel';
import Link from './Link';
Tabs.Panel = Panel;
Tabs.Link = Link;
Tabs.displayName = 'ShineoutTabs';
export default Tabs;